import { FC, useState } from 'react';
import clsx from 'clsx';
import { ICardProps } from '../List';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Card.module.scss';
import { useTypedSelector } from '../../../../../../lib/hooks/useTypedSelector';
import { commodityTypes } from '../../../../../../data/commodityTypes';
import { generateImageUrl } from '../../../../../../helpers/generateImageUrl';
import Favorites from '../../../../../Icons/Favorites';
import Cart from '../../../../ProductPage/Cart';
import Comment from '../../../../../Icons/Comment';
import ModalAddToCart from '../../../../../ModalAddToCart/ModalAddToCart';
import { updateFavorites } from '../../../../../../helpers/favorites';
import { ICardProps as IFavorites } from '../../../../FavoritesPage/components/Card/Card';
import ModalComment from '../../../../../ModalComment/ModalComment';
import StatusNew from '../../../../../StatusNew/StatusNew';

interface ICatalogCard {
  data: ICardProps;
  favorites: IFavorites[];
}

const Card: FC<ICatalogCard> = ({ data, favorites }) => {
  const navigate = useNavigate();
  const { cart } = useTypedSelector((state) => state);
  const indexInCart = cart.findIndex((item) => item.product_id === data.id);
  const [isModalActive, setModalActive] = useState(false);
  const handleModalOpen = () => {
    setModalActive(true);
  };
  const handleModalClose = () => {
    setModalActive(false);
  };
  const [commentVisible, setCommentVisible] = useState(false);
  const [isModalCommentActive, setModalCommentActive] = useState(false);
  const handleModalCommentOpen = () => {
    setModalCommentActive(true);
  };
  const handleModalCommentClose = () => {
    setModalCommentActive(false);
  };

  const [indexInfavorites, setIndexInFavorites] = useState<number>(
    favorites.findIndex((item) => item.id === data.id),
  );

  const updateFavoritesList = (data: IFavorites) => {
    if (indexInfavorites === -1) {
      updateFavorites(data, 'add').then(() => {
        setIndexInFavorites(1);
      });
    } else
      updateFavorites(data, 'delete').then(() => {
        setIndexInFavorites(-1);
      });
  };

  let replacedByItem =
    data?.replaceBy && Array.isArray(data?.replaceBy)
      ? data.replaceBy.filter(
          (i) =>
            i.displayData.status &&
            i.displayData.status !== 'discontinued' &&
            i.displayData.isActive,
        )[0] || null
      : null;

  return (
    <>
      <Link
        to={'/product/' + data.id}
        state={{ type: data.isExtra ? 'accessory' : data.type }}
        className={styles.Card}
      >
        <div>
          <img
            src={
              data.image?.s3Key
                ? generateImageUrl(data.image?.s3Key)
                : '/images/placeholderImage.png'
            }
            className={styles.image}
          />
        </div>
        <div className={styles.card_wrapper}>
          <div className={styles.wrapper}>
            {data.status && (
              <div className={styles.status_holder}>
                <StatusNew status={data.status} count={data.count || 0} />
              </div>
            )}

            <h2>
              <img
                src={
                  data.isExtra
                    ? commodityTypes['accessory'].icon
                    : commodityTypes[data.type as keyof typeof commodityTypes]
                        .icon
                }
                alt={data.type}
              />{' '}
              {data.article_number} — {data.name}
            </h2>
            <div className={styles.content_holder}>
              <div className={styles.content}>
                <span>Бренд: {data.brand?.name}</span>
                <span>Категория: {data.category?.name}</span>
                {data.model && <span>Модель: {data.model}</span>}
              </div>
              {replacedByItem && data.type !== 'product' ? (
                <>
                  <div>
                    <span>
                      Замена на: {replacedByItem.displayData?.partCode}
                    </span>
                  </div>
                </>
              ) : null}
            </div>
          </div>

          <div className={styles.button_holder}>
            <div className={styles.buttons}>
              <button
                className={clsx(styles.favorites_btn, {
                  [styles.product]: data.type === 'product',
                })}
                onClick={(e) => {
                  e.preventDefault();
                  updateFavoritesList(data as IFavorites);
                }}
              >
                <Favorites active={indexInfavorites !== -1} />
                {data.type === 'product' && (
                  <span>
                    {indexInfavorites !== -1 ? 'В избранном' : 'В избранное'}
                  </span>
                )}
              </button>
              {(!data.status || data.status === 'discontinued') &&
              !replacedByItem
                ? null
                : (data.in_stoke || replacedByItem) &&
                  (indexInCart === -1 ? (
                    <button
                      className={clsx(styles.cart_btn, styles.active)}
                      onClick={(e) => {
                        e.preventDefault();
                        handleModalOpen();
                      }}
                    >
                      В корзину
                    </button>
                  ) : (
                    <div className={styles.cart_holder}>
                      <button
                        className={clsx(styles.cart_btn)}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('/cart');
                        }}
                      >
                        {cart[indexInCart].count} <Cart />
                      </button>
                      {cart[indexInCart].comment && (
                        <div
                          className={clsx(styles.comment, {
                            [styles.open]: commentVisible,
                          })}
                          onPointerEnter={() => setCommentVisible(true)}
                          onPointerLeave={() => setCommentVisible(false)}
                          onClick={(e) => {
                            (e.preventDefault(), handleModalCommentOpen());
                          }}
                        >
                          <Comment />
                          <p>{cart[indexInCart].comment}</p>
                        </div>
                      )}
                    </div>
                  ))}
            </div>
          </div>
        </div>
      </Link>
      {isModalCommentActive && (
        <ModalComment
          onClose={handleModalCommentClose}
          comment={cart[indexInCart].comment || ''}
        />
      )}
      {isModalActive && (
        <ModalAddToCart
          onClose={handleModalClose}
          data={{
            available:
              !data.count && replacedByItem
                ? replacedByItem.metaData.count
                : data.count,
            product_id:
              !data.count && replacedByItem ? replacedByItem.id : data.id,
            cmmf:
              !data.count && replacedByItem
                ? replacedByItem.displayData.cmmf
                : data.cmmf,
            article_number:
              !data.count && replacedByItem
                ? replacedByItem.displayData.partCode
                : data.article_number,
            name:
              !data.count && replacedByItem
                ? replacedByItem.displayData.name
                : data.name,
            status:
              !data.count && replacedByItem
                ? replacedByItem.displayData.status || ''
                : data.status || '',
            type:
              !data.count && replacedByItem
                ? replacedByItem.displayData.type
                : data.type,
            image:
              !data.count && replacedByItem
                ? replacedByItem.displayData.image?.s3Key || ''
                : data.image?.s3Key || '',
            count: 1,
          }}
        />
      )}
    </>
  );
};

export default Card;
